import { ScrollRestoration } from "react-router-dom";
import FooterSection from "screens/home/widgets/FooterSection/footerSection";
import Navbar from "widgets/Navbar/Navbar";
import ProductSection from "./widgets/ProductsSection/ProductSection";

export default function ProductScreen() {
  return (
    <div>
      <ScrollRestoration/>
      <Navbar />
      <div style={{ height: "48px" }} />
      <ProductSection />
      <div style={{ height: "64px" }} />
      <FooterSection />
    </div>
  );
}
